import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  // One shared, equal left/right gutter for every tab's content, instead of
  // each tab picking its own width (95%, 90vw/73vw via Wrapper, padding, none).
  tabPanelContainer: {
    flex: 1,
    minWidth: 0,
    padding: '0 24px',
  },
};

export default styles;
